import { ChangeEvent, FC, useState } from 'react';
import { Capacitor } from '@capacitor/core';
import { setAppLoading, useAppDispatch } from 'store';
import { RadabankPinCode } from 'components/RadabankCard';
import { PASSWORD_LENGTH } from 'utils/constants';
import { ERROR_MESSAGE, STORAGE_KEY } from 'utils/enums';
import { encryptData } from 'utils/helpers';
import { RadabankService, StorageService } from 'utils/services';
import { RestoreRadabankPasswordStepProps } from '../../data';
import styles from './index.module.scss';

export const RestoreRadabankPasswordPinCodeStep: FC<RestoreRadabankPasswordStepProps> = ({
	initialValues,
	onSaveData,
	onError,
}) => {
	const dispatch = useAppDispatch();
	const [passwords, setPasswords] = useState({
		password: '',
		password_confirm: '',
	});
	const [isRepeatedPin, setIsRepeatedPin] = useState(false);
	const [error, setError] = useState('');

	const handleChangePassword = (e: ChangeEvent<HTMLInputElement>) => {
		const { value } = e.target;
		setPasswords((prev) => ({ ...prev, password: value }));
		if (value.length === PASSWORD_LENGTH) {
			setIsRepeatedPin(true);
		}
	};

	const handleChangeConfirmPassword = (e: ChangeEvent<HTMLInputElement>) => {
		const { value } = e.target;
		setPasswords((prev) => ({ ...prev, password_confirm: value }));
		if (value.length === PASSWORD_LENGTH) {
			if (value === passwords.password) {
				handleSubmit({ password: passwords.password, password_confirm: value });
				return;
			}
			setError(ERROR_MESSAGE.PASSWORDS_DO_NOT_MATCH);
			setPasswords((prev) => ({ ...prev, password_confirm: '' }));
		} else {
			setError('');
		}
	};

	const handleSubmit = async (values: typeof passwords) => {
		try {
			dispatch(setAppLoading(true));
			await RadabankService.resetPasswordSet({ ...initialValues, ...values });
			if (Capacitor.isNativePlatform()) {
				await StorageService.set(STORAGE_KEY.USER_PASSWORD, encryptData(values.password));
			}
			onSaveData?.(values);
		} catch (error) {
			onError(error);
		} finally {
			dispatch(setAppLoading(false));
		}
	};

	return (
		<div className={styles.pin}>
			{!isRepeatedPin ? (
				<RadabankPinCode
					maxLength={PASSWORD_LENGTH}
					error={error}
					value={passwords.password}
					onChange={handleChangePassword}
					key="set-password"
					description="Придумайте новий PIN-код"
				/>
			) : (
				<RadabankPinCode
					maxLength={PASSWORD_LENGTH}
					error={error}
					value={passwords.password_confirm}
					onChange={handleChangeConfirmPassword}
					key="confirm-password"
					description="Підтвердіть новий PIN-код"
				/>
			)}
		</div>
	);
};
